import { useNavigate, useParams } from "react-router-dom";
import { COMMON_CONSTANTS, I18_TRANSLATION_COMMON, NUMBER_CONSTANTS } from "../../../Utilities/Constants/Constants";
import { Container } from "@mui/material";
import { useEffect, useState } from "react";
import React from "react";
import { useSelector } from "react-redux";
import { axiosInstance } from "../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../Utilities/Constants/ApiEndpoints";
import "./Tickets.scss";
import BackArrow from "../../../../Assets/schools/back_button.svg";
import { useTranslation } from "react-i18next";
import { Card } from "@mui/material";
import moment from 'moment';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const BookingDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const [ThemeParkHubList, setThemeParkHubList] = useState<any>([])
  const [ActiveList, setActiveList] = useState<any>(
    NUMBER_CONSTANTS.ONE
  );

  useEffect(() => {
    const pathName = window.location?.pathname;
    const payload = {
      record_area: pathName.slice(1)
    }
    axiosInstance.post(`${API_END_POINTS?.RECORD_AREA}`, payload).then((response: any) => {
    }).catch(() => {
    })
  }, [])

  useEffect(() => {
    getThemeParkHubData("")
  }, [])
  const getThemeParkHubData = (value: any) => {
    axiosInstance

      .get(
        `${API_END_POINTS.THEMEPARK_HUB + `?id=${id}`}`
      )
      .then((Response: any) => {
        if (Response?.data?.status) {
          setThemeParkHubList(Response?.data?.result?.data);
        }
      })
      .catch(() => { });
  };

  const onNavigate = (booked_id: any, id: any, state: any) => {
    navigate(`/manage-guest-users/${booked_id}/bookings/${id}`, { state: state })
  }

  return (
    <>
      <React.Fragment>
        <Container component="main" maxWidth="xl" sx={{ mb: 4 }}>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div className="arrow-wrap">
                <img
                  alt="Learn and Play"
                  src={BackArrow}
                  className="EditSchool-backarrow"
                  onClick={() => {
                    navigate(-1);
                  }}
                />
                <h5 className="name-title mt-1 ms-1">{t("Booking Detail")}</h5>
              </div>
            </div>
          </div>

          <div className="Tutor_hup__container">
            <div className="header__section">
              <div className={ActiveList === 3 ? " themepark_active" : "title"} >
                Theme park Bookings
              </div>
            </div>
            <div className="my-tickets-wrapper">
              <div className="card-wrapper-ticket">
                {ThemeParkHubList?.map((ticket: any, index: number) => {
                  return (
                    <Card className="ticket-card" onClick={() => onNavigate(ticket.booked_user_id, ticket.id, ticket.ticket_type_details)}>
                      <div className="image-wrapper">
                        <img className="theme-image" src={ticket.themepark_image} />
                        <div className="ticket-name-location">
                          <h5>{ticket.themepark_name}</h5>
                          <p><LocationOnIcon className="location-icon" />{ticket.city ? ticket.city : "N/A"}</p>
                        </div>
                      </div>

                      <div className="theme-details mt-2">
                        <div className="row">
                          <div className="col-sm-6 col-md-6">
                            <p className="theme-title">{t("Contact No")}</p>
                          </div>
                          <div className="col-sm-6 col-md-6">
                            <p className="theme-value">{ticket.phone_number}</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6 col-md-6">
                            <p className="theme-title">{t("Booked ID")}</p>
                          </div>
                          <div className="col-sm-6 col-md-6">
                            <p className="theme-value">{ticket.id}</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6 col-md-6">
                            <p className="theme-title">{t("Booked Date")}</p>
                          </div>
                          <div className="col-sm-6 col-md-6">
                            <p className="theme-value">{moment(new Date(ticket.created_on)).format("DD/MM/YYYY")}</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6 col-md-6">
                            <p className="theme-title">{t("Booked By")}</p>
                          </div>
                          <div className="col-sm-6 col-md-6">
                            <p className="theme-value">{ticket.parent_name}</p>
                          </div>
                        </div>
                      </div>
                    </Card>
                  )
                })
                }

              </div>

            </div>

          </div>
        </Container>
      </React.Fragment>
    </>
  );

};
export default BookingDetail;